import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { RiDashboardHorizontalLine } from "react-icons/ri";
import { GrHelpBook } from "react-icons/gr";
import { GiProgression } from "react-icons/gi";
import { useDispatch } from "react-redux";
import { SelectLanguageData } from "../../Redux/Reducers/Common/Language";
import { useSelector } from "react-redux";
const QBAdminMenu = (props) => {
    const LoginDetails = useSelector(
        (state) => state.userDetailsData.LoginDetails
    );
    const dispatch = useDispatch();
    const navigate = useNavigate();
    return (
        <>
            <div onClick={() => {
                localStorage.removeItem("FSelected");
                navigate("/QBAdmin/QuestionBank", { state: { Tab: "SCQ", Topic: "0", }, });
            }}
                className={props.CheckPath("/QuestionBank") ? "SubTabSelect" : "TabNotSelect"} >  <GrHelpBook />  Question Bank </div>

            <div onClick={() => { navigate("/QBAdmin/OverallDashboard", { state: { Tab: "SCQ" }, }); }}
                className={props.CheckPath("/OverallDashboard") ? "SubTabSelect" : "TabNotSelect"} >
                <RiDashboardHorizontalLine /> Overall Dashboard </div>

                <div onClick={() => {
                    const GetEnglish = JSON.parse(localStorage.getItem("LanguageOptions")).filter((item) => item.display === "English");
                    dispatch(SelectLanguageData({ SLanguage: GetEnglish?.[0]?.value.toString(), }));
                    navigate("/QBAdmin/QuestionStatus", { state: { Tab: "SCQ" }, });
                }}
                    className={props.CheckPath("/QuestionStatus") ? "SubTabSelect" : "TabNotSelect"} >
                    <RiDashboardHorizontalLine /> Question Status </div>

            <div onClick={() => {
                const GetEnglish = JSON.parse(localStorage.getItem("LanguageOptions")).filter((item) => item.display === "English");
                dispatch(SelectLanguageData({ SLanguage: GetEnglish?.[0]?.value.toString(), }));
                navigate("/QBAdmin/Progresstracker", { state: { Tab: "SCQ" }, });
            }}
                className={props.CheckPath("/Progresstracker") ? "SubTabSelect" : "TabNotSelect"} >
                <GiProgression />  Progress tracker </div>
            {LoginDetails?.subjectId != 4 && LoginDetails?.subjectId != 5 && <>
                <div onClick={() => { navigate("/QBAdmin/QSTrack", { state: { Tab: "SCQ" }, }); }}
                    className={props.CheckPath("/QSTrack") ? "SubTabSelect" : "TabNotSelect"} >
                    <GiProgression />  Question Status tracker </div>
            </>}
        </>
    )
}
export default QBAdminMenu;